var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon",
    className: "bi bi-chevron-right ms-2",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1570"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Rechteck_496",
    className: "bi-chevron-right-square",
    d: "M6.5,0h0c3.5899,0,6.5,2.9101,6.5,6.5h0c0,3.5899-2.9101,6.5-6.5,6.5h0C2.9101,13,0,10.0899,0,6.5H0C0,2.9101,2.9101,0,6.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Icon_ionic-md-arrow-round-forward",
    className: "bi-chevron-right-arrow",
    d: "M7.243,10.525l3.549-3.444c.153-.152,.2366-.3604,.231-.576v-.01c.0056-.2156-.078-.424-.231-.576l-3.549-3.443c-.2867-.3065-.7677-.3225-1.0742-.0358-.0123,.0115-.0243,.0235-.0358,.0358-.3061,.3269-.3061,.8351,0,1.162l2.133,2.041H2.766c-.4543,.0158-.8097,.3969-.7938,.8512,.0151,.432,.3618,.7788,.7938,.7938h5.5l-2.136,2.04c-.3061,.3269-.3061,.8351,0,1.162,.2886,.3071,.7714,.3221,1.0785,.0335,.0119-.0111,.0234-.0227,.0345-.0345Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.013e250c.svg";
export { ForwardRef as ReactComponent };